import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[href]',
  host: { '(click)': 'preventDefault($event)' }
})
export class HrefPreventDefaultDirective implements AfterViewInit {
  @Input()
  href: string;

  constructor(private el: ElementRef) {}
  ngAfterViewInit() {}
  preventDefault(event) {
    if (this.el.nativeElement.className.indexOf('makeCall') >= 0) {
      return;
    }
    if (this.href.length === 0 || this.href === '#') {
      event.preventDefault();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/_directives/href-prevent-default.directive.ts